import { GameConfig } from '../../domain/entities';

export const mensGameConfig: GameConfig = {
    LEAGUE_NAMES: ['Prem Division', 'First Division', 'League One', 'League Two'],
    WEEKS_PER_SEASON: 60,
    LEAGUE_CONFIG: {
        'Prem Division': { teams: 20, promotion: 0, relegation: 3 },
        'First Division':   { teams: 24, promotion: 3, relegation: 3 },
        'League One':     { teams: 24, promotion: 3, relegation: 4 },
        'League Two':     { teams: 24, promotion: 4, relegation: 0 },
    },
    PRIZE_MONEY: {
        'Prem Division': { positions: [50000000, 40000000, 30000000] }, // Prize for top 3
        'First Division':   { promotion: 10000000 },
        'League One':     { promotion: 5000000 },
        'League Two':     { promotion: 2000000 },
    },
    CUP_NAMES: ['Pixel Cup', 'Junior Cup'],
    CUP_CONFIG: {
        'Pixel Cup': {
            name: 'Pixel Cup',
            prizeMoney: [40000, 80000, 160000, 320000, 640000, 1280000, 2560000], // Per round winner prize
            tvMoneyPerGame: 75000,
        },
        'Junior Cup': {
            name: 'Junior Cup',
            prizeMoney: [15000, 30000, 60000, 120000, 240000, 500000], // Meaningful prize money for lower league clubs
            tvMoneyPerGame: 35000,
        }
    },
};